import React, { useState } from 'react'
import { Alert } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Confirm = (props) => {
  //eslint-disable-next-line
  const [show, setShow] = useState(true);
  //eslint-disable-next-line
  const deleteContact = () => {
    props.deleteContact();
  }
  const deleteCommission = () => {
    props.deleteCommission();
  }
  const deleteHandover = () => {
    props.deleteHandover();
  }
  //eslint-disable-next-line
  const deleteSubject = () => {
    props.deleteSubject();
  }
  //eslint-disable-next-line
  const deleteClass = () => {
    props.deleteClass();
  }
  //eslint-disable-next-line
  const deleteCourse = () => {
    props.deleteCourse();
  }
  //eslint-disable-next-line
  const deleteCourseRegistration = () => {
    props.deleteCourseRegistration();
  }
  //eslint-disable-next-line
  const deleteFile = () => {
    props.deleteFile();
  }
  const deleteWarranty = () => {
    props.deleteWarranty();
  }
  
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

      <Alert show={show} variant="danger" className='mb-0'>
        <Alert.Heading>{props.title}</Alert.Heading>
        <p>
          {props.message}
        </p>
        <hr />
        <div className="d-flex justify-content-end">
          {props.table === "contact" &&
            <Button onClick={props.deleteContact} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "pricebook" &&
            <Button onClick={props.deletePricebook} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "repair" &&
            <Button onClick={props.deleteRepairTicket} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "task" &&
            <Button onClick={props.deleteTask} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "warranty" &&
            <Button onClick={props.deleteWarranty} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "archive" &&
            <Button onClick={props.archiveLeads} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "file" &&
            <Button onClick={props.deleteFile} variant="danger" className='mx-2'>
             Yes
            </Button>
          }
          {props.table === "payment" &&
            <Button onClick={props.deletepayment} variant="danger" className='mx-2'>
             Yes
            </Button>
          }
          {/* Added By Farhan Khan Khan on 16-Sep-2023 Active Inactive Registrations */}
          {props.table === "courseregistrationsInactiveTable" &&
            <Button onClick={props.inactiveCourseRegistration} variant="danger" className='mx-2'>
             Yes
            </Button>
          } {props.table === "courseregistrationsActiveTable" &&
            <Button onClick={props.inactiveCourseRegistration} variant="danger" className='mx-2'>
            Yes .
            </Button>
        }
          {props.table === "Brand" &&
            <Button onClick={props.deleteProduct} variant="danger" className='mx-2'>
            Yes
            </Button>
          }
          {props.table === "Product" &&
            <Button onClick={props.deleteProduct} variant="danger" className='mx-2'>
            Yes
            </Button>
          }
          {props.table === "BOM" &&
            <Button onClick={props.deleteProduct} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "financial_subsidy" &&
            <Button onClick={props.onConfirm} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "Quotation" &&
            <Button onClick={props.deleteProduct} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "lead" &&
            <Button onClick={props.deleteLead} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "offer" &&
            <Button onClick={props.deleteOffer} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "order" &&
            <Button onClick={props.deleteOrder} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "orderAmc" &&
            <Button onClick={props.deleteOrderAmc} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "account" &&
            <Button onClick={props.deleteAccount} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "commission" &&
            <Button onClick={props.deleteCommission} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "handover" &&
            <Button onClick={props.deleteHandover} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "role" &&
            <Button onClick={props.deleteRole} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          {props.table === "permission" &&
            <Button onClick={props.deletePermission} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          <Button onClick={props.onHide} variant="light" className="" title=''>
            No
          </Button>
        </div>
      </Alert>
    </Modal>
  )
}

export default Confirm